export enum ChannelType {
  None = 0,
  GoogleAdwords = 1,
  GoogleOrganic = 2,
  FacebookAds = 3,
  Direct = 4,
  FacebookOrganic = 5,
  Referral = 6,
  Phone = 7,
  InstagramAds = 8,
  LinkedinLeads = 9,
  Outbrain = 10,
  Newsletter = 11,
  Youtube = 12,
  FacebookAdLeadPage = 13,
  FacebookAdLeadCampaign = 14,
  InstagramAdLeadCampaign = 15,
  TV = 16,
  Radio = 17,
  Print = 18,
  Crm = 19,
  FacebookComments = 20,
  FacebookMessenger = 21,
  CrmCallCenter = 22,
  CrmImport = 23,
  WhatsAppOrganic = 24,
  InstagramComments = 25,
  InstagramMessenger = 26,
  GoogleLeads = 27,
  WhatsAppPhone = 28,
  TikTokOrganic = 29,
  TikTokAds = 30,
  TikTokLeads = 31,
  TikTokComments = 32,
  LinkedinAds = 33,
  Lms = 34,
  InstagramOrganic = 35,
  LinkedinOrganic = 36,

  FormLeads = -1,
}

export enum AvailableChannelMetadataTypesMode {
  Campaigns = 0,
  Leads = 1,
  MediaCampaigns = 2,
}

export const AvailableChannelMetadataTypes: ChannelType[] = [
  ChannelType.GoogleAdwords,
  ChannelType.GoogleLeads,
  ChannelType.GoogleOrganic,
  ChannelType.FacebookAds,
  ChannelType.FacebookAdLeadCampaign,
  ChannelType.FacebookOrganic,
  ChannelType.InstagramAds,
  ChannelType.InstagramAdLeadCampaign,
  ChannelType.Phone,
  ChannelType.Referral,
  ChannelType.Direct,
  ChannelType.TV,
  ChannelType.Radio,
  ChannelType.Print,
  ChannelType.Youtube,
  ChannelType.Outbrain,
  ChannelType.LinkedinLeads,
  ChannelType.LinkedinAds,
  ChannelType.Newsletter,
  ChannelType.Crm,
  ChannelType.CrmCallCenter,
  ChannelType.CrmImport,
  ChannelType.FacebookComments,
  ChannelType.FacebookMessenger,
  ChannelType.InstagramComments,
  ChannelType.InstagramMessenger,
  ChannelType.WhatsAppOrganic,
  ChannelType.WhatsAppPhone,

  ChannelType.FormLeads,
  ChannelType.TikTokAds,
  ChannelType.TikTokLeads,
  ChannelType.TikTokOrganic,
  ChannelType.InstagramOrganic,
  ChannelType.LinkedinOrganic,
];

export const ChannelMetadataTypesForCampaigns: ChannelType[] = [
  ChannelType.GoogleAdwords,
  ChannelType.GoogleLeads,
  ChannelType.FacebookAds,
  ChannelType.FacebookAdLeadCampaign,
  ChannelType.Outbrain,
  ChannelType.InstagramAds,
  ChannelType.Referral,
  ChannelType.TikTokAds,
  ChannelType.TikTokLeads,
];

export const ChannelMetadataTypesForMediaCampaigns: ChannelType[] = [
  ChannelType.Phone,
  ChannelType.Print,
  ChannelType.Radio,
  ChannelType.TV,
  ChannelType.WhatsAppPhone,
];
